"use client"

import clsx from "clsx"
import { MouseEventHandler } from "react"
import { Icon, IconName } from "./Icon"

export type OverlayButtonProps = {
  iconName: IconName
  iconClassName?: string
  title: string
  disabled?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export const OverlayButton = ({ iconName, iconClassName, title, disabled, onClick }: OverlayButtonProps) => (
  <button
    type="button"
    disabled={disabled}
    title={title}
    onClick={onClick}
    className={clsx(
      "bg-np-green10/75 relative flex size-12 shrink-0 items-center justify-center rounded-full shadow backdrop-blur-xs transition-colors hover:transition-none",
      {
        hidden: disabled,
        "hover:bg-np-green25 active:bg-np-green10": !disabled,
      },
    )}
  >
    <Icon name={iconName} className={clsx("text-np-green size-9", iconClassName)} />
  </button>
)
